import { MODULES } from "#constants/modules"
import DescriptionIcon from "@mui/icons-material/Description"
import Index from "./pages/Index"
import UploadPaymentFile from "./pages/UploadPaymentFile"
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PERFILES from "#constants/perfiles"
import { PRIMARYCOLOR } from "#constants/Styles";
const { GRTE_RH, } = PERFILES

export const URLS = {
	"Recibos Nomina": [
		{
			module: MODULES.SALARIES,
			path: "salaries",
			element: <Index />,
			title: "Recibos Nomina",
			icon: DescriptionIcon ,
			permissions: [GRTE_RH],
			textDivider: "Salarios",
		},
		{
			module: MODULES.SALARIES,
			path: "subir-salarios",
			element: <UploadPaymentFile />,
			title: "Subir Salarios",
			icon: PriceCheckIcon ,
			permissions: [GRTE_RH],
			textDivider: "Salarios",
		},
	],
}
